import React, { Component } from 'react'
import "./rightslider.css"
import im1 from "../../assets/1.JPG";
import im2 from '../../assets/2.JPG';
import im3 from '../../assets/3.JPG';
import im4 from '../../assets/4.JPG';
import im5 from '../../assets/5.JPG';
import im6 from '../../assets/6.JPG';


export default class Rightslider extends Component {
    render() {
        return (
            <div className="right-slider">
                <div className="right-slide-track">
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im1} alt="" />
                    </div>
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im2} alt="" />
                    </div>
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im3} alt="" />
                    </div>
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im4} alt="" />
                    </div>
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im5} alt="" />
                    </div>
                    <div className="right-slide">
                        <img className="beachhack-slider-imgs" src={im6} alt="" />
                    </div>
                </div>
            </div>
        )
    }
}
